import {axiosInstanceWithToken}  from "../utils/Client";

export default class SickLeaveService {


    static getStaffSickLeaveInfo = () => {
        return axiosInstanceWithToken.get(`/sickleave/staff/info/`);
    };

    static getUserSickLeaveInfo = (locationId) => {
        return axiosInstanceWithToken.get(`/sickleave/user/info/${locationId}/`);
    };

    static getSickLeaveSetting = (locationId, year) => {
        return axiosInstanceWithToken.get(`/sickleave/setting/${locationId}/?year=${year}`);
    };

    static saveSickLeaveSetting = (locationId, settingObj, year) => {
        return axiosInstanceWithToken.put(
            `/sickleave/setting/${locationId}/?year=${year}`, settingObj
        );
    };

    static createSickLeaveRequest = (requestObj) => {
        return axiosInstanceWithToken.post(`/sickleave/request/`, requestObj);
    };

    static getPaidSickLeaveUsers = (id, year) => {
        return axiosInstanceWithToken.get(`/sickleave/eligibleusers/${id}/?year=${year}`);
    };

    static modifyPaidSickLeaveUsers = (data) => {
        return axiosInstanceWithToken.put(`/sickleave/eligibleusers/`, data);
    };

    static cancelSickLeaveRequest = (objectId, requestObj) => {
        return axiosInstanceWithToken.delete(`/sickleave/request/${objectId}`, requestObj);
    };

    static modifySickLeaveRequest = (objectId, requestObj) => {
        return axiosInstanceWithToken.put(`/sickleave/request/${objectId}/`, requestObj);
    };

    static getUserSickLeaveRequests = (userId,year) => {
        return axiosInstanceWithToken.get(`/sickleave/request/list/all/${userId}/?year=${year}`);
    };

    static getSickLeaveSetting = (locationId, year) => {
        return axiosInstanceWithToken.get(
            `/sickleave/setting/${locationId}/?year=${year}`
        );
    };

    static getuserList = (locationId) => {
        return axiosInstanceWithToken.get(`/users_except_agency_monitor/${locationId}/`);
    };
}



// WEBPACK FOOTER //
// ./src/services/SickLeaveServices.js